import { makePropertyMetadataEntriesFetchKey } from './cacheKeys';
import { fetchPropertyMetadataEntries } from './propertyMetadata';
import { wrapPromise } from 'persist-promise/wrapPromise';
export const propertyMetadataPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'propertyMetadata',
  deepFreeze: true,
  toCacheKey: makePropertyMetadataEntriesFetchKey,
  fetch: fetchPropertyMetadataEntries
});